import React, { useEffect, useRef } from "react";
import videojs from "video.js";
import "video.js/dist/video-js.css";
import { Box } from "@mui/material";

const VideoJSPlayer = ({ url, sourceType, autoFullscreen, onClose }) => {
    const videoRef = useRef(null);
    const playerRef = useRef(null);

    useEffect(() => {
        if (videoRef.current && url && !playerRef.current) {
            playerRef.current = videojs(videoRef.current, {
                controls: true,
                preload: "auto",
                liveui: true,
                sources: [
                    {
                        src: url,
                        type: sourceType,
                    },
                ],
            });

            playerRef.current.on("canplay", () => {
                playerRef.current.play();
            });
        }

        return () => {
            if (playerRef.current) {
                playerRef.current.dispose();
                playerRef.current = null;
            }
        };
    }, [url, sourceType]);

    // entra in fullscreen automaticamente quando viene montato
    useEffect(() => {
        if (autoFullscreen && videoRef.current) {
            const el = videoRef.current;

                if (el.requestFullscreen) el.requestFullscreen();
                else if (el.webkitRequestFullscreen) el.webkitRequestFullscreen();
                else if (el.msRequestFullscreen) el.msRequestFullscreen();

        }
    }, [autoFullscreen]);

    useEffect(() => {
        const handleFullscreenChange = () => {
            // se non c’è più un elemento in fullscreen, chiama la onClose
            if (!document.fullscreenElement && typeof onClose === "function") {
                onClose();
            }
        };

        document.addEventListener("fullscreenchange", handleFullscreenChange);
        return () => {
            document.removeEventListener("fullscreenchange", handleFullscreenChange);
        };
    }, [onClose]);

    return (
        <Box
            sx={{
                position: "relative",
                width: "100%",
                height: "auto",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <video
                ref={videoRef}
                className="video-js vjs-big-play-centered"
                style={{
                    width: "100%",
                    height: "auto",
                    maxHeight: "85vh",
                    objectFit: "contain",
                }}
                controls
                preload="auto"
            ></video>
        </Box>
    );
};

export default VideoJSPlayer;
